export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "Consignments",
      layout: "dashboard",
    },
    path: "/consignments",
    name: "consignments",
    component: () => import("@/layouts/index/ConsignmentIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Liste des consignments",
          layout: "dashboard",
        },
        path: "index",
        name: "consignments-index",
        component: () => import("@/views/consignments/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer un consignment",
          layout: "dashboard",
        },
        path: "create",
        name: "consignments-create",
        component: () => import("@/views/consignments/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails du consignment",
          layout: "dashboard",
        },
        path: ":reference/details",
        name: "consignments-details",
        component: () => import("@/views/consignments/Details.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier le consignment",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "consignments-edit",
        component: () => import("@/views/consignments/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Ajouter des coûts à un consignment",
          layout: "dashboard",
        },
        path: "costs/create",
        name: "consignment-costs-create",
        component: () => import("@/views/consignments/costs/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Liste des coûts de consignment",
          layout: "dashboard",
        },
        path: "costs/index",
        name: "consignment-costs-index",
        component: () => import("@/views/consignments/costs/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier les coûts d'un consignment",
          layout: "dashboard",
        },
        path: ":reference/costs/edit",
        name: "consignment-costs-edit",
        component: () => import("@/views/consignments/costs/Edit.vue"),
      },
    ],
  },
];
